export default __webpack_public_path__ + "i18n/translations/translation-zh.b2a7066d.json";